import { Link } from 'react-router-dom';
import { computeCoverageReport } from '@web-studio/layout-matrix';

const QUICK_LINKS: readonly {
  to: string;
  label: string;
  hint: string;
  external?: boolean;
}[] = [
  {
    to: '/mockups/hinoki-counter-film.html',
    label: 'Hinoki Recipe B mockup',
    hint: 'Counter-film composition preview (static HTML)',
    external: true,
  },
  {
    to: '/mockups/ivory-calligraphy.html',
    label: 'Kasumi · Ivory calligraphy',
    hint: 'Candidate sushi theme — light paper + dual photo band',
    external: true,
  },
  {
    to: '/mockups/press-nigiri-night.html',
    label: 'Akami · Press nigiri night',
    hint: 'Candidate sushi theme — jewel hero + dish cards',
    external: true,
  },
  {
    to: '/matrix/hero-stock',
    label: 'Restaurant hero stock',
    hint: 'Preview platform photos on hero sections',
  },
  {
    to: '/matrix/block/Hero_Editorial_Split?mode=engineer&targets=1',
    label: 'Open block',
    hint: 'Engineer mode · edit targets',
  },
  {
    to: '/matrix/grid/Hero_Editorial_Split',
    label: 'Compare blocks',
    hint: 'Same fixture across themes',
  },
  {
    to: '/matrix/parity',
    label: 'Batch Checkup',
    hint: 'SSR Checkup across blocks',
  },
];

export function OverviewPage() {
  const report = computeCoverageReport();

  return (
    <div className="lab-page">
      <header className="lab-page-header">
        <h1 className="lab-page-header__title">Layout Matrix Explorer</h1>
        <p className="lab-page-header__desc">
          Examine every implemented block across all themes, colorsets, spacing enums, and locales.
          Registry-only blocks appear in gallery and coverage with a placeholder status.
        </p>
      </header>

      <div className="lab-stats">
        <StatCard label="Themes" value={String(report.themes)} />
        <StatCard label="Colorsets" value={String(report.colorsets)} />
        <StatCard label="Rendered cells" value={String(report.renderedCells)} />
        <StatCard label="Implemented blocks" value={String(report.implementedBlocks)} />
      </div>

      <div className="lab-overview-grid">
        <section className="lab-panel">
          <div className="lab-panel__body">
            <h2 className="lab-panel__title">Workflows</h2>
            <p className="lab-panel__desc">Jump into the matrix modes you use most often.</p>
            <div className="lab-actions mt-4">
              {QUICK_LINKS.map((item) => {
                const body = (
                  <>
                    <span>
                      <span className="block">{item.label}</span>
                      <span
                        className="mt-0.5 block text-xs font-normal"
                        style={{ color: 'var(--lab-muted)' }}
                      >
                        {item.hint}
                      </span>
                    </span>
                    <span className="lab-action__chevron" aria-hidden />
                  </>
                );
                return item.external ? (
                  <a key={item.to} className="lab-action" href={item.to}>
                    {body}
                  </a>
                ) : (
                  <Link key={item.to} className="lab-action" to={item.to}>
                    {body}
                  </Link>
                );
              })}
            </div>
          </div>
        </section>

        <aside className="lab-callout">
          <p className="lab-callout__label">Engineer mode</p>
          <p className="lab-callout__body">
            Block isolate includes fixture editing, edit-target overlay, and SSR Checkup. Append{' '}
            <code>?mode=engineer&amp;targets=1&amp;parity=1</code> on isolate URLs.
          </p>
        </aside>
      </div>
    </div>
  );
}

function StatCard({ label, value }: { label: string; value: string }) {
  return (
    <div className="lab-stat">
      <p className="lab-stat__label">{label}</p>
      <p className="lab-stat__value">{value}</p>
    </div>
  );
}
